import React, { useState, useContext, useEffect } from "react";
import { AppSettings } from "../../config/app-settings.js";
import useAuthStore from "../../stores/auth-store.js";

function GroundTruthRoadsTraffic() {
  const context = useContext(AppSettings);
  const user = useAuthStore((state) => state.user);

  // Setup app layout
  useEffect(() => {
    context.handleSetAppContentClass('');
    context.handleSetAppSidebarNone(true);
    context.handleSetAppSidebarTwo(false);
    context.handleSetAppSidebarWide(false);
    context.handleSetAppTopMenu(true);

    return () => {
      context.handleSetAppSidebarNone(false);
      context.handleSetAppSidebarTwo(false);
      context.handleSetAppSidebarWide(false);
      context.handleSetAppTopMenu(false);
    };
  }, [context]);

  // Form state
  const [formData, setFormData] = useState({
    zoneId: "10",
    roadNamePrimary: "",
    roadNameSecondary: "",
    roadwayType: "",
    roadCondition: "",
    conditionDescription: "",
    roadEvents: [],
    trafficManagementControl: [],
    signage: "",
    cones: "",
    notes: "",
  });

  const roadwayTypes = [
    "Signalized Intersection",
    "Unsignalized Intersection",
    "Roundabout Intersection",
    "2-way Roadway",
    "1-way Roadway",
  ];

  const roadConditions = ["Clear", "Partially Blocked", "Fully Blocked"];

  const roadEventOptions = [
    "Accident",
    "Stalled Vehicle",
    "Major Debris/Tree",
    "Flooding",
  ];

  const trafficControlOptions = [
    "Signal Timing Plan",
    "Traffic Control Persons (TCP/Flaggers)",
    "Contraflow (1 or more lanes reversed)",
    "Single-Lane Alternating Traffic (SLAT)",
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (e, fieldName) => {
    const { value, checked } = e.target;
    setFormData((prev) => {
      const updatedArray = checked
        ? [...prev[fieldName], value]
        : prev[fieldName].filter((item) => item !== value);
      return {
        ...prev,
        [fieldName]: updatedArray,
      };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Ground Truth Road/Traffic Data Submitted:", formData);
    alert("Ground Truth Road/Traffic data submitted (cosmetic only)");
  };

  const handleReset = () => {
    setFormData({
      zoneId: "10",
      roadNamePrimary: "",
      roadNameSecondary: "",
      roadwayType: "",
      roadCondition: "",
      conditionDescription: "",
      roadEvents: [],
      trafficManagementControl: [],
      signage: "",
      cones: "",
      notes: "",
    });
  };

  return (
    <div className="container-fluid mt-3 mb-3">
      <div className="row">
        <div className="col-12">
          <div className="card border-0 shadow-lg">
            <div className="card-header bg-dark text-white">
              <h5 className="mb-0">
                <i className="fa fa-road me-2"></i>
                Ground Truth - Field Crew (Roads & Traffic)
              </h5>
            </div>

            <div className="card-body p-3">
              <form onSubmit={handleSubmit}>
                {/* Zone and Road Info Section */}
                <div className="row mb-3">
                  <div className="col-md-2 mb-2">
                    <label htmlFor="zoneId" className="form-label small fw-bold">
                      Zone ID
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="zoneId"
                      name="zoneId"
                      value={formData.zoneId}
                      onChange={handleInputChange}
                      readOnly
                      disabled
                    />
                  </div>
                  <div className="col-md-3 mb-2">
                    <label htmlFor="roadNamePrimary" className="form-label small fw-bold">
                      Road Name - Primary
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="roadNamePrimary"
                      name="roadNamePrimary"
                      value={formData.roadNamePrimary}
                      onChange={handleInputChange}
                      placeholder="e.g., Highway 97"
                    />
                  </div>
                  <div className="col-md-3 mb-2">
                    <label htmlFor="roadNameSecondary" className="form-label small fw-bold">
                      Secondary / Cross Street
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="roadNameSecondary"
                      name="roadNameSecondary"
                      value={formData.roadNameSecondary}
                      onChange={handleInputChange}
                      placeholder="e.g., Main Street"
                    />
                  </div>
                  <div className="col-md-4 mb-2">
                    <label className="form-label small fw-bold">Roadway Type</label>
                    <select
                      className="form-select form-select-sm"
                      name="roadwayType"
                      value={formData.roadwayType}
                      onChange={handleRadioChange}
                    >
                      <option value="">Select Type...</option>
                      {roadwayTypes.map((type) => (
                        <option key={type} value={type}>
                          {type}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Road Condition and Events Section */}
                <div className="row mb-3">
                  <div className="col-md-3 mb-2">
                    <label className="form-label small fw-bold">Road Condition</label>
                    <div className="border rounded p-2 bg-light">
                      {roadConditions.map((condition) => (
                        <div className="form-check form-check-sm" key={condition}>
                          <input
                            className="form-check-input"
                            type="radio"
                            name="roadCondition"
                            id={`roadCondition_${condition}`}
                            value={condition}
                            checked={formData.roadCondition === condition}
                            onChange={handleRadioChange}
                          />
                          <label className="form-check-label small" htmlFor={`roadCondition_${condition}`}>
                            {condition}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="col-md-3 mb-2">
                    <label className="form-label small fw-bold">Road Events (select all)</label>
                    <div className="border rounded p-2 bg-light">
                      {roadEventOptions.map((event) => (
                        <div className="form-check form-check-sm" key={event}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={`roadEvent_${event}`}
                            value={event}
                            checked={formData.roadEvents.includes(event)}
                            onChange={(e) => handleCheckboxChange(e, "roadEvents")}
                          />
                          <label className="form-check-label small" htmlFor={`roadEvent_${event}`}>
                            {event}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="col-md-3 mb-2">
                    <label className="form-label small fw-bold">Traffic Control (select all)</label>
                    <div className="border rounded p-2 bg-light">
                      {trafficControlOptions.map((control) => (
                        <div className="form-check form-check-sm" key={control}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={`trafficControl_${control}`}
                            value={control}
                            checked={formData.trafficManagementControl.includes(control)}
                            onChange={(e) => handleCheckboxChange(e, "trafficManagementControl")}
                          />
                          <label className="form-check-label small" htmlFor={`trafficControl_${control}`}>
                            {control}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="col-md-3 mb-2">
                    <div className="row g-1 h-100">
                      <div className="col-12">
                        <label className="form-label small fw-bold">Signage</label>
                        <div className="border rounded p-1 bg-light">
                          {["Yes-VMS", "Yes-Regular", "No"].map((opt) => (
                            <div className="form-check form-check-sm" key={opt}>
                              <input
                                className="form-check-input"
                                type="radio"
                                name="signage"
                                id={`signage_${opt}`}
                                value={opt}
                                checked={formData.signage === opt}
                                onChange={handleRadioChange}
                              />
                              <label className="form-check-label small" htmlFor={`signage_${opt}`}>
                                {opt}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="col-12">
                        <label className="form-label small fw-bold">Cones</label>
                        <div className="border rounded p-1 bg-light">
                          {["Yes", "No"].map((opt) => (
                            <div className="form-check form-check-sm" key={opt}>
                              <input
                                className="form-check-input"
                                type="radio"
                                name="cones"
                                id={`cones_${opt}`}
                                value={opt}
                                checked={formData.cones === opt}
                                onChange={handleRadioChange}
                              />
                              <label className="form-check-label small" htmlFor={`cones_${opt}`}>
                                {opt}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Condition Description, Notes and Photo Section */}
                <div className="row mb-3">
                  <div className="col-md-5 mb-2">
                    <label htmlFor="conditionDescription" className="form-label small fw-bold">
                      Condition Description
                    </label>
                    <textarea
                      className="form-control form-control-sm"
                      id="conditionDescription"
                      name="conditionDescription"
                      rows="3"
                      value={formData.conditionDescription}
                      onChange={handleInputChange}
                      placeholder="Describe road condition..."
                    ></textarea>
                  </div>

                  <div className="col-md-5 mb-2">
                    <label htmlFor="notes" className="form-label small fw-bold">
                      Notes
                    </label>
                    <textarea
                      className="form-control form-control-sm"
                      id="notes"
                      name="notes"
                      rows="3"
                      value={formData.notes}
                      onChange={handleInputChange}
                      placeholder="Additional observations..."
                    ></textarea>
                  </div>

                  <div className="col-md-2 mb-2 d-flex flex-column">
                    <label className="form-label small fw-bold mb-2">Actions</label>
                    <button type="button" className="btn btn-secondary btn-sm mb-2 flex-grow-1">
                      <i className="fa fa-camera me-1"></i>
                      Take Photo
                    </button>
                  </div>
                </div>

                {/* Form Actions */}
                <div className="d-flex gap-2 justify-content-end mt-2">
                  <button
                    type="reset"
                    className="btn btn-secondary btn-sm"
                    onClick={handleReset}
                  >
                    <i className="fa fa-redo me-2"></i>
                    Reset
                  </button>
                  <button type="submit" className="btn btn-primary btn-sm">
                    <i className="fa fa-save me-2"></i>
                    Submit Report
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GroundTruthRoadsTraffic;
